import React from 'react';
import { useTranslation } from 'react-i18next';
import qs from 'qs';
import connection from '../../../assets/svg/connection.svg';
import notfound from '../../../assets/svg/404.svg';
import error from '../../../assets/svg/errorPage.svg';
// import React, { useContext } from 'react';
// import { Link, Redirect } from 'react-router-dom';
// import error from '../../../assets/404.svg';
// import { PATH_INTRO, PATH_ROOT } from '../../paths';
// import {
//   ErrorContainer, ErrorSubText, ErrorText, ErrorWhiteButton,
// } from './styles';
// import { Title } from '../../design/Title';
// import { Content, Img, ImgHolder } from '../../design/StandartPage/styles';
// import RootContext from '../../context';

export const Error = () => {
  // const { videoParams } = useContext(RootContext);
  // if (!videoParams) return <Redirect to={`${PATH_ROOT}${PATH_INTRO}`}/>;
  const { t } = useTranslation();
  let { type } = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  type = type || '';

  let image,
    title,
    text;

  switch (type) {
    case '404':
      image = notfound;
      title = t('errorNotFoundTitle');
      text = t('errorNotFoundText');
      break;
    case 'connection':
      image = connection;
      title = t('errorConnectionTitle');
      text = t('errorConnectionText');
      break;
    case 'noBackendURL':
      image = error;
      title = t('errorParametersTitle');
      text = t('errorNoBackendURLText');
      break;
    case 'noProjectId':
      image = error;
      title = t('errorParametersTitle');
      text = t('errorNoProjectIdText');
      break;
    case 'badBackendURL':
      image = error;
      title = t('errorParametersTitle');
      text = t('errorBadBackendURLText');
      break;
    case 'failed':
      image = error;
      title = t('errorErrorTitle');
      text = t('errorFailedText');
      break;
    case 'declined':
      image = error;
      title = t('declinedErrorTitle');
      text = t('declinedText');
      break;
    default:
      image = error;
      title = t('errorErrorTitle');
      text = t('errorErrorText');
      break;
  }

  return (
    <>
      <img className={`widget-error-image ${type === '404' && 'widget-fullWidth-image'}`} src={image} alt="error" />
      <p className="widget-error-title">{title}</p>
      <p className="widget-error-text">{text}</p>
      {/* <p onClick={() => set('start')} className="widget-cancel"> */}
      {/*  {t('cancelButton')} */}
      {/* </p> */}
    </>
  );
};

/*
    <ErrorContainer>
      <ImgHolder>
        <Img src={error}/>
      </ImgHolder>
      <Content>
        <Title>
          Web Active Liveness
        </Title>
        <ErrorText>
          <Link to={`${PATH_ROOT}${PATH_INTRO}`}>
            by Enface
          </Link>
          <ErrorSubText>
Web Active Liveness check by enface.ai can be described as biometric verification as
the
protection of personal data.
<br/>
<br/>
As the biometric component, the system uses facial recognition with liveness feature.
  Enface
uses active and passive liveness for anti-spoofing protection.
</ErrorSubText>
<br/>
<Title size={'18px'}>
How to start using
</Title>
<ErrorSubText>
<ul style={{ marginLeft: '-20px' }}>
<li><span>Allow access to the camera</span></li>
<li><span>Take off anything from your face</span></li>
<li><span>Position yor face in the camera frame</span></li>
</ul>
</ErrorSubText>
<ErrorWhiteButton>Join our slack</ErrorWhiteButton>
</ErrorText>
</Content>
</ErrorContainer>
 */
